import * as React from 'react';
import { ILabelOption } from './types';
import * as styles from './Labels.css';

interface ILabelsProps {
  options: ILabelOption[];
  onClick: (value: number) => void;
}

export function Labels({ options, onClick }: ILabelsProps) {
  return (
    <ul className={styles['labels']}>
      {options.map((item, index) => (
        <li key={index} className={styles['label-item']}>
          <button type="button" onClick={() => onClick(item.value)} className={styles['label']}>
            {item.label}
          </button>
        </li>
      ))}
    </ul>
  );
}
